import { EntityTypeLabels } from '@core/services/gbe-error-parser/entity-ref-labels';
import { ICONS } from '@core/services/icons/icons.service';

const TARGET_ICONS: Readonly<Record<string, string>> = {
  vehicle: ICONS.truck,
  driver: ICONS.user,
  trailer: ICONS.truckTrailer,
  site: ICONS.warehouse,
  job: ICONS.package
};

/** Takes a string: a stored requirement may name a target this build does not know. */
export function targetIcon(target: string): string {
  return TARGET_ICONS[target] ?? ICONS.funnel;
}

export function targetDisplayName(target: string, names: EntityTypeLabels): string {
  return names.get(target.toUpperCase()) ?? target;
}
